import React from 'react';
import MagnifierIcon from './magnifier.svg?jsx';

import { useTranslator } from 'tradera-lang/translate';

const ZeroResults = () => {
    const { t } = useTranslator();

    return (
        <div
            data-zero-results
            className="p-md-5 mt-md-5 mx-lg-0 mx-1 d-flex flex-column align-items-center">
            <MagnifierIcon className="mb-4" width="160" height="150" />
            <h4 className="text-styled text-center">
                {t('searchResults_zeroResults_title')}
            </h4>
            <div>
                <h5>
                    <strong>{t('searchResults_zeroResults_hint')}</strong>
                </h5>
                <ul className="formatted">
                    <li>{t('searchResults_zeroResults_bullets_1')}</li>
                    <li>{t('searchResults_zeroResults_bullets_2')}</li>
                    <li>{t('searchResults_zeroResults_bullets_3')}</li>
                    <li>{t('searchResults_zeroResults_bullets_4')}</li>
                </ul>
            </div>
        </div>
    );
};

export default React.memo(ZeroResults);
